<template>
  <div class="container">
    <div class="row mt-2" v-if="$gate.isAdminOrAuthor()">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Artesões</h3>

            <div class="card-tools">
              <button class="btn btn-success" @click="newModal">
                <i class="fas fa-user-plus"></i> Adicionar Artesão
              </button>
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body table-responsive p-0">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nome</th>
                  <th>CPF</th>
                  <th>Data de Nascimento</th>
                  <th>Registro</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="art in arts.data" :key="art.id">
                  <td>{{art.id}}</td>
                  <td>{{art.nome}}</td>
                  <td>{{art.cpf}}</td>
                  <td>{{art.data_nascimento | myDate}}</td>
                  <td>{{art.created_at | myDate}}</td>

                  <td>
                    <a href="#" @click="editModal(art)">
                      <i class="fa fa-edit blue"></i>
                    </a>
                    /
                    <a href="#" @click="deleteArt(art.id)">
                      <i class="fa fa-trash red"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.card-body -->

          <div v-if="arts.total > 0" class="card-footer">
            <pagination :data="arts" @pagination-change-page="getResults"></pagination>
          </div>
        </div>

        <!-- /.card -->
      </div>
    </div>

    <div v-if="!$gate.isAdminOrAuthor()">
      <not-found />
    </div>
    <div
      class="modal fade"
      id="addNew"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addNew"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              v-show="!editMode"
              class="col-11 modal-title text-center"
              id="addNew"
            >CADASTRO DE ARTESÃOS</h5>
            <h5 v-show="editMode" class="col-11 modal-title text-center" id="addNew">EDITAR ARTESÃO</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit.prevent>
            <div class="modal-body">
              <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="pills-home-tab"
                    data-toggle="pill"
                    href="#pills-home"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                    @click.prevent="setActive('principal')"
                    :class="{ active: isActive('principal') }"
                  >Informações Pessoais e Adicionais</a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="pills-profile-tab"
                    data-toggle="pill"
                    href="#pills-profile"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                    @click.prevent="setActive('info')"
                    :class="{ active: isActive('info'), disabled: isDisabledPrincipal}"
                  >Informações Financeiras</a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="pills-contact-tab"
                    data-toggle="pill"
                    href="#pills-contact"
                    role="tab"
                    aria-controls="pills-contact"
                    aria-selected="false"
                    @click.prevent="setActive('producao')"
                    :class="{ active: isActive('producao'),disabled: isDisabledInfo }"
                  >Produção</a>
                </li>
              </ul>
              <div class="tab-content" id="pills-tabContent">
                <div
                  class="tab-pane fade show"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                  :class="{ 'active show': isActive('principal') }"
                >
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>Objetivo do Cadastro</label>
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                id="participar_feira"
                                value="true"
                                v-model="form.checked_participar_feira"
                              />
                              <label
                                for="participar_feira"
                                class="custom-control-label"
                              >Para participar de feira</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                id="ganhar_desconto"
                                value="true"
                                v-model="form.checked_desconto"
                              />
                              <label
                                for="ganhar_desconto"
                                class="custom-control-label"
                              >Para ganhar desconto</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label>Nome*</label>
                      <input
                        v-model="form.nome"
                        type="text"
                        name="nome"
                        placeholder="Digite seu nome"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('nome') }"
                      />
                      <has-error :form="form" field="nome"></has-error>
                    </div>

                    <div class="form-group col-md-2">
                      <label>Nome (Perfil do Facebook)</label>
                      <input
                        v-model="form.perfil_facebook"
                        type="text"
                        name="perfil_facebook"
                        placeholder="Digite seu nome no facebook"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('perfil_facebook') }"
                      />
                      <has-error :form="form" field="perfil_facebook"></has-error>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label>CPF*</label>
                      <input
                        v-model="form.cpf"
                        v-mask="'###.###.###-##'"
                        masked="false"
                        type="text"
                        name="cpf"
                        placeholder="Digite seu CPF"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('cpf') }"
                      />
                      <has-error :form="form" field="cpf"></has-error>
                    </div>

                    <div class="form-group col-md-3">
                      <label>Identidade*</label>
                      <input
                        v-model="form.identidade"
                        type="text"
                        v-mask="'##.###.###-#'"
                        name="identidade"
                        placeholder="Digite sua Identidade"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('identidade') }"
                      />
                      <has-error :form="form" field="identidade"></has-error>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Órgão expedidor</label>
                      <input
                        v-model="form.orgao_exp"
                        type="text"
                        name="orgao_exp"
                        placeholder="Digite o Orgão Expedidor"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('orgao_exp') }"
                      />
                      <has-error :form="form" field="orgao_exp"></has-error>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Data emissão</label>
                      <input
                        v-model="form.data_emissao"
                        type="date"
                        name="data_emissao"
                        placeholder="Digite a Data de Emissão"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('data_emissao') }"
                      />
                      <has-error :form="form" field="data_emissao"></has-error>
                    </div>
                    <div class="form-group col-md-2">
                      <label>Data de Nascimento*</label>
                      <input
                        v-model="form.data_nascimento"
                        type="date"
                        name="data_nascimento"
                        placeholder="Digite a Data de Nascimento"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('data_nascimento') }"
                      />
                      <has-error :form="form" field="data_nascimento"></has-error>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>Nome do Pai</label>
                      <input
                        v-model="form.nome_pai"
                        type="text"
                        name="nome_pai"
                        placeholder="Digite o nome do Pai"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('nome_pai') }"
                      />
                      <has-error :form="form" field="nome_pai"></has-error>
                    </div>

                    <div class="form-group col-md-6">
                      <label>Nome da Mãe</label>
                      <input
                        v-model="form.nome_mae"
                        type="text"
                        name="nome_mae"
                        placeholder="Digite o nome do Mãe"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('nome_mae') }"
                      />
                      <has-error :form="form" field="nome_mae"></has-error>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>Endereço*</label>
                      <input
                        v-model="form.logradouro"
                        type="text"
                        name="logradouro"
                        placeholder="Digite o Endereço"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('logradouro') }"
                      />
                      <has-error :form="form" field="logradouro"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label>Número*</label>
                      <input
                        v-model="form.numero"
                        type="text"
                        name="numero"
                        placeholder="Digite o Número"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('numero') }"
                      />
                      <has-error :form="form" field="numero"></has-error>
                    </div>

                    <div class="form-group col-md-3">
                      <label>Complemento</label>
                      <input
                        v-model="form.complemento"
                        type="text"
                        name="complemento"
                        placeholder="Digite o Complemento"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('complemento') }"
                      />
                      <has-error :form="form" field="complemento"></has-error>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label>Bairro*</label>
                      <input
                        v-model="form.bairro"
                        type="text"
                        name="bairro"
                        placeholder="Digite o Bairro"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('bairro') }"
                      />
                      <has-error :form="form" field="bairro"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label>CEP*</label>
                      <input
                        v-model="form.cep"
                        v-mask="'#####-###'"
                        type="text"
                        name="cep"
                        placeholder="Digite o CEP"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('cep') }"
                      />
                      <has-error :form="form" field="cep"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label>UF*</label>
                      <input
                        v-model="form.uf"
                        type="text"
                        name="uf"
                        placeholder="Digite o UF"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('uf') }"
                      />
                      <has-error :form="form" field="uf"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="urg_id">Região (URG)*</label>
                      <select
                        v-model="form.urg_id"
                        class="form-control"
                        id="urg_id"
                        :class="{ 'is-invalid': form.errors.has('urg_id') }"
                      >
                        <option value disabled>Selecione uma Região</option>
                        <option v-for="urg in urgs" :key="urg.id" :value="urg.id">{{urg.descricao}}</option>
                      </select>
                      <has-error :form="form" field="urg_id"></has-error>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label>E-mail</label>
                      <input
                        v-model="form.email"
                        type="text"
                        name="email"
                        placeholder="Digite o E-mail"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('email') }"
                      />
                      <has-error :form="form" field="email"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label>Telefone*</label>
                      <input
                        v-model="form.telefone"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        type="text"
                        name="telefone"
                        placeholder="Digite o Telefone"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('telefone') }"
                      />
                      <has-error :form="form" field="telefone"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="escolaridade_id">Escolaridade*</label>
                      <select
                        class="form-control"
                        v-model="form.escolaridade_id"
                        id="escolaridade_id"
                        :class="{ 'is-invalid': form.errors.has('escolaridade_id') }"
                      >
                        <option value disabled>Selecione sua Escolariadade</option>
                        <option
                          v-for="escolaridade in escolaridades"
                          :key="escolaridade.id"
                          v-bind:value="escolaridade.id"
                        >{{escolaridade.descricao}}</option>
                      </select>
                      <has-error :form="form" field="escolaridade_id"></has-error>
                    </div>
                  </div>
                  <div class="form-group">
                    <h6 class="text-muted">2. Identificação</h6>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="sexo">Sexo*</label>
                      <select
                        v-model="form.sexo"
                        class="form-control"
                        id="sexo"
                        :class="{ 'is-invalid': form.errors.has('sexo') }"
                      >
                        <option value disabled>Selecione o Sexo</option>
                        <option value="M">Masculino</option>
                        <option value="F">Feminino</option>
                      </select>
                      <has-error :form="form" field="sexo"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="estado_civil">Estado Cilvil*</label>
                      <select
                        v-model="form.estado_civil"
                        class="form-control"
                        id="estado_civil"
                        :class="{ 'is-invalid': form.errors.has('estado_civil') }"
                      >
                        <option value disabled>Selecione o Estado Civil</option>
                        <option value="S">Solteiro</option>
                        <option value="C">Casado</option>
                        <option value="V">Viúvo</option>
                        <option value="D">Divorciado</option>
                        <option value="O">Outros</option>
                      </select>
                      <has-error :form="form" field="estado_civil"></has-error>
                    </div>

                    <div class="form-group col-md-3">
                      <label for="quantidade_dependente">Possui quantos Dependentes</label>
                      <select
                        v-model="form.quantidade_dependente"
                        class="form-control"
                        id="quantidade_dependente"
                        :class="{ 'is-invalid': form.errors.has('estado_civil') }"
                      >
                        <option value disabled>Selecione a Quantidade de Dependentes</option>
                        <option>1</option>
                        <option>2</option>
                        <option>3</option>
                        <option>4</option>
                        <option>5 ou mais</option>
                      </select>
                      <has-error :form="form" field="quantidade_dependente"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="vive_imovel">Vive em Imóvel*</label>
                      <select
                        v-model="form.vive_imovel"
                        class="form-control"
                        id="vive_imovel"
                        :class="{ 'is-invalid': form.errors.has('estado_civil') }"
                      >
                        <option value disabled>Selecione o Tipo de Imóvel</option>
                        <option value="P">Próprio</option>
                        <option value="A">Alugado</option>
                        <option value="C">Cedido</option>
                        <option value="O">Outros</option>
                      </select>
                      <has-error :form="form" field="vive_imovel"></has-error>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="etnia">Como você se Auto Denomina*</label>
                      <select
                        v-model="form.etnia"
                        class="form-control"
                        id="etnia"
                        :class="{ 'is-invalid': form.errors.has('etnia') }"
                      >
                        <option value disabled>Selecione sua Auto Denominação</option>
                        <option value="B">Branca</option>
                        <option value="P">Parda</option>
                        <option value="N">Negra</option>
                        <option value="I">Indígena</option>
                      </select>
                      <has-error :form="form" field="etnia"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="portador_necessidades">Portador de Necessidades Especiais*</label>
                      <select
                        v-model="form.portador_necessidades"
                        class="form-control"
                        id="portador_necessidades"
                        :class="{ 'is-invalid': form.errors.has('portador_necessidades') }"
                      >
                        <option value disabled>Selecione se possui Necessidades Especiais</option>
                        <option value="S">Sim</option>
                        <option value="N">Não</option>
                      </select>
                      <has-error :form="form" field="portador_necessidades"></has-error>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="sel1">Digite a Necessidade Especial</label>
                      <input
                        v-model="form.portador_necessidades_descricao"
                        type="text"
                        name="portador_necessidades_descricao"
                        placeholder="Digite o tipo de Necessidade Especial"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('portador_necessidades_descricao') }"
                      />
                    </div>
                    <has-error :form="form" field="portador_necessidades_descricao"></has-error>
                  </div>
                  <div class="form-row"></div>
                  <div class="form-group">
                    <h6 class="text-muted">3. Perfil</h6>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="tempo_artesao">É artesão há quanto tempo*</label>
                      <select
                        v-model="form.tempo_artesao"
                        class="form-control"
                        id="tempo_artesao"
                        :class="{ 'is-invalid': form.errors.has('tempo_artesao') }"
                      >
                        <option value disabled>Selecione o período</option>
                        <option>Menos de 6 meses</option>
                        <option>6 meses a 1 ano</option>
                        <option>1 a 3 anos</option>
                        <option>3 a 5 anos</option>
                        <option>Mais de 5 anos</option>
                      </select>
                      <has-error :form="form" field="tempo_artesao"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="atividade">O artesanato é sua atividade*</label>
                      <select
                        v-model="form.atividade"
                        class="form-control"
                        id="atividade"
                        :class="{ 'is-invalid': form.errors.has('atividade') }"
                      >
                        <option value disabled>Selecione a atividade</option>
                        <option>Principal</option>
                        <option>Secundária</option>
                        <option>Sazonal</option>
                      </select>
                      <has-error :form="form" field="atividade"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="causa_ingresso">Porque ingressou na atividade Artesanal</label>
                      <select
                        class="form-control"
                        v-model="form.causa_ingresso"
                        id="causa_ingresso"
                        :class="{ 'is-invalid': form.errors.has('causa_ingresso') }"
                      >
                        <option value disabled>Selecione o causa</option>
                        <option>Tradição familiar</option>
                        <option>Realização pessoal</option>
                        <option>Complemento de renda</option>
                        <option>Curso de formação</option>
                        <option>Falta de opção</option>
                        <option>Outros</option>
                      </select>
                      <has-error :form="form" field="causa_ingresso"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="vinculo_institucional">Possui algum vínculo institucional*</label>
                      <select
                        v-model="form.vinculo_institucional"
                        class="form-control"
                        id="vinculo_institucional"
                        :class="{ 'is-invalid': form.errors.has('vinculo_institucional') }"
                      >
                        <option value disabled>Selecione o vínculo institucional</option>
                        <option>Não</option>
                        <option>Com sindicato de artesãos</option>
                        <option>Federação</option>
                        <option>Com cooperativas de artesãos</option>
                        <option>Com associação de artesãos</option>
                        <option>Com org. de apoio ao artesão</option>
                        <option>Outros</option>
                      </select>
                      <has-error :form="form" field="vinculo_institucional"></has-error>
                    </div>
                  </div>
                  <div class="form-row" v-show="!editMode">
                    <div class="form-group col-md-6">
                      <label>Quais os principais problemas que enfrenta na atividade artesanal</label>
                      <div
                        v-for="(problemas, key, index) in groupProblemas"
                        :key="index"
                        class="row"
                      >
                        <div class="col-sm-6" v-for="(value, key, index) in problemas" :key="index">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                :id="value.id"
                                :value="value.id"
                                v-model="form.checked_problemas"
                              />
                              <label
                                :for="value.id"
                                class="custom-control-label"
                              >{{value.descricao}}</label>
                            </div>
                            <!--       <div class="custom-control custom-checkbox">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                id="customCheckbox2"
                                value="option2"
                              />
                              <label for="customCheckbox2" class="custom-control-label">Divulgação</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                id="customCheckbox3"
                                value="option3"
                              />
                              <label
                                for="customCheckbox3"
                                class="custom-control-label"
                              >Comercialização</label>
                            </div>

                            <div class="custom-control custom-checkbox">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                id="customCheckbox4"
                                value="option4"
                              />
                              <label for="customCheckbox4" class="custom-control-label">Embalagem</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                id="customCheckbox5"
                                value="option5"
                              />
                              <label
                                for="customCheckbox5"
                                class="custom-control-label"
                              >Capacitação e Orientação técnica</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                id="customCheckbox6"
                                value="option6"
                              />
                              <label
                                for="customCheckbox6"
                                class="custom-control-label"
                              >Equipamentos e instrumentos de trabalho</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                id="customCheckbox7"
                                value="option7"
                              />
                              <label
                                for="customCheckbox7"
                                class="custom-control-label"
                              >Formação de preço dos produtos</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                id="customCheckbox8"
                                value="option8"
                              />
                              <label for="customCheckbox8" class="custom-control-label">Informação</label>
                            </div>
                            <div class="custom-control custom-checkbox">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                id="customCheckbox9"
                                value="option9"
                              />
                              <label for="customCheckbox9" class="custom-control-label">Outros</label>
                            </div>-->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label
                        for="sel1"
                      >Especifique os principais problemas enfrentados na atividade artesanal</label>
                      <input
                        type="text"
                        name="instrutor_tecnico"
                        placeholder="Digite os principais problemas enfrentados na atividade artesanal"
                        class="form-control"
                      />
                      <has-error :form="form" field="vinculo_institucional"></has-error>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label for="instrutor_tecnico">É instrutor de curso de técnica de artesanal*</label>
                      <select
                        v-model="form.instrutor_tecnico"
                        class="form-control"
                        id="instrutor_tecnico"
                        :class="{ 'is-invalid': form.errors.has('instrutor_tecnico') }"
                      >
                        <option value disabled>Selecione se é instrutor de curso</option>
                        <option value="S">Sim</option>
                        <option value="N">Não</option>
                      </select>
                      <has-error :form="form" field="instrutor_tecnico"></has-error>
                    </div>
                    <div class="form-group col-md-2">
                      <label for="instrutor_tecnico_descricao">Especificar técnica</label>
                      <input
                        v-model="form.instrutor_tecnico_descricao"
                        id="instrutor_tecnico_descricao"
                        type="text"
                        name="instrutor_tecnico_descricao"
                        placeholder="Digite a técnica"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('instrutor_tecnico_descricao') }"
                      />
                      <has-error :form="form" field="instrutor_tecnico"></has-error>
                    </div>
                    <div class="form-group col-md-2">
                      <label for="instrutor_tecnico_ano">Desde quando (ano)</label>
                      <input
                        v-model="form.instrutor_tecnico_ano"
                        id="instrutor_tecnico_ano"
                        type="text"
                        name="instrutor_tecnico_ano"
                        placeholder="Digite o ano"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('necessidadeespecial') }"
                      />
                      <has-error :form="form" field="instrutor_tecnico_ano"></has-error>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="sel1">Como conheceu o Programa Municipal de Artesanato?</label>
                      <input
                        v-model="form.como_conheceu"
                        id="como_conheceu"
                        type="text"
                        name="como_conheceu"
                        placeholder="Digite onde conheceu o Programa Municipal de Artesanato"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('como_conheceu') }"
                      />
                      <has-error :form="form" field="como_conheceu"></has-error>
                    </div>
                  </div>
                  <div class="form-group">
                    <h6 class="text-muted">4. Capacitação</h6>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label
                        for="atividade_capacitacao"
                      >Já participou de alguma atividade de capacitação</label>
                      <select
                        class="form-control"
                        v-model="form.atividade_capacitacao"
                        id="atividade_capacitacao"
                        :class="{ 'is-invalid': form.errors.has('como_conheceu') }"
                      >
                        <option
                          value
                          disabled
                        >Selecione se já participou de alguma atividade de capacitação</option>
                        <option value="S">Sim</option>
                        <option value="N">Não</option>
                      </select>
                      <has-error :form="form" field="atividade_capacitacao"></has-error>
                    </div>
                    <div class="form-group col-md-2">
                      <label for="tipo_capacitacao">Tipo de capacitação</label>
                      <select
                        class="form-control"
                        v-model="form.tipo_capacitacao"
                        id="tipo_capacitacao"
                        :class="{ 'is-invalid': form.errors.has('como_conheceu') }"
                      >
                        <option value disabled>Selecione o tipo de capacitação</option>
                        <option>Curso</option>
                        <option>Palestra</option>
                        <option>Missão Técnica</option>
                        <option>Oficina</option>
                        <option>Consultoria Técnica</option>
                        <option>Seminário</option>
                        <option>Outras</option>
                      </select>
                      <has-error :form="form" field="tipo_capacitacao"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="tipo_capacitacao_descricao">Qual Capacitação</label>
                      <input
                        type="text"
                        v-model="form.tipo_capacitacao_descricao"
                        name="tipo_capacitacao_descricao"
                        id="tipo_capacitacao_descricao"
                        placeholder="Digite qual Capacitação"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('tipo_capacitacao_descricao') }"
                      />
                      <has-error :form="form" field="tipo_capacitacao_descricao"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="area_capacitacao">Área</label>
                      <select
                        class="form-control"
                        id="area_capacitacao"
                        v-model="form.area_capacitacao"
                        :class="{ 'is-invalid': form.errors.has('area_capacitacao') }"
                      >
                        <option value disabled>Selecione o Área</option>
                        <option>Gestão</option>
                        <option>Técnica Artesanal</option>
                        <option>Associativismo e corporativismo</option>
                        <option>Design</option>
                        <option>Comportamental</option>
                        <option>Outros</option>
                      </select>
                      <has-error :form="form" field="area_capacitacao"></has-error>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label for="sel1">Qual Área</label>
                      <input
                        v-model="form.area"
                        type="text"
                        name="area"
                        placeholder="Digite a Área"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('area') }"
                      />
                      <has-error :form="form" field="area"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="nome_capacitacao">Nome da atividade de capacitação</label>
                      <input
                        v-model="form.nome_capacitacao"
                        type="text"
                        id="nome_capacitacao"
                        name="nome_capacitacao"
                        placeholder="Digite a atividade de capacitação"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('nome_capacitacao') }"
                      />
                      <has-error :form="form" field="nome_capacitacao"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="data_capacitacao">Data</label>
                      <input
                        v-model="form.data_capacitacao"
                        type="date"
                        id="data_capacitacao"
                        name="data_capacitacao"
                        placeholder="Digite a data da capacitação"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('data_capacitacao') }"
                      />
                      <has-error :form="form" field="data_capacitacao"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="carga_horaria_capacitacao">Carga Horária</label>
                      <input
                        v-model="form.carga_horaria_capacitacao"
                        type="text"
                        id="carga_horaria_capacitacao"
                        name="carga_horaria_capacitacao"
                        placeholder="Digite a carga horária"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('carga_horaria_capacitacao') }"
                      />
                      <has-error :form="form" field="carga_horaria_capacitacao"></has-error>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="entidade_capacitacao">Entidade promotora</label>
                      <input
                        v-model="form.entidade_capacitacao"
                        type="text"
                        id="entidade_capacitacao"
                        name="entidade_capacitacao"
                        placeholder="Digite a entidade promotora"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('entidade_capacitacao') }"
                      />
                      <has-error :form="form" field="entidade_capacitacao"></has-error>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="local_capacitacao">Local de realização</label>
                      <input
                        v-model="form.local_capacitacao"
                        type="text"
                        id="local_capacitacao"
                        name="local_capacitacao"
                        placeholder="Digite o local da realização"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('local_capacitacao') }"
                      />
                      <has-error :form="form" field="local_capacitacao"></has-error>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="pills-profile"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab"
                  :class="{ 'active show': isActive('info') }"
                >
                  <div class="form-group">
                    <h6 class="text-muted">5. Ocupação e Renda</h6>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-3">
                      <label>Local de produção*</label>
                      <select
                        class="form-control"
                        id="local_producao"
                        v-model="form.local_producao"
                        :class="{ 'is-invalid': form.errors.has('local_producao') }"
                      >
                        <option value disabled>Selecione o local de produção</option>
                        <option>Na própria residência</option>
                        <option>Centro de artesanato</option>
                        <option>Associação</option>
                        <option>Cooperativa</option>
                        <option>Outros</option>
                      </select>
                      <has-error :form="form" field="local_producao"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="sel1">Especificar</label>
                      <input
                        type="text"
                        id="local_producao_descricao"
                        v-model="form.local_producao_descricao"
                        name="local_producao_descricao"
                        placeholder="Digite o local de produção"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('local_producao_descricao') }"
                      />
                      <has-error :form="form" field="local_producao_descricao"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="sel1">Sistema de Trabalho*</label>
                      <select
                        v-model="form.sistema_trabalho"
                        class="form-control"
                        id="sistema_trabalho"
                        :class="{ 'is-invalid': form.errors.has('sistema_trabalho') }"
                      >
                        <option value disabled>Selecione o sistema de trabalho</option>
                        <option>Individual</option>
                        <option>Cooperativas</option>
                        <option>Com outros artesãos</option>
                        <option>Com Familiares</option>
                        <option>Outros</option>
                      </select>
                      <has-error :form="form" field="sistema_trabalho"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="sel1">Especificar</label>
                      <input
                        v-model="form.sistema_trabalho_descricao"
                        type="text"
                        name="sistema_trabalho_descricao"
                        placeholder="Digite o sistema de trabalho"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('sistema_trabalho_descricao') }"
                      />
                    </div>
                    <has-error :form="form" field="sistema_trabalho_descricao"></has-error>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="horas_dedicadas">Número de horas dedicadas à produção artesanal</label>
                      <select
                        v-model="form.horas_dedicadas"
                        class="form-control"
                        id="horas_dedicadas"
                        :class="{ 'is-invalid': form.errors.has('sistema_trabalho_descricao') }"
                      >
                        <option value disabled>Selecione as horas dedicadas à produção artesanal</option>
                        <option>Até 2 horas</option>
                        <option>De 2 a 4 horas</option>
                        <option>De 4 a 6 horas</option>
                        <option>De 6 a 8 horas</option>
                        <option>Mais de 8 horas</option>
                      </select>
                      <has-error :form="form" field="sistema_trabalho_descricao"></has-error>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="contribui_inss">Contribui para a Previdência Social (INSS)*</label>
                      <select
                        v-model="form.contribui_inss"
                        class="form-control"
                        id="contribui_inss"
                        :class="{ 'is-invalid': form.errors.has('contribui_inss') }"
                      >
                        <option
                          value
                          disabled
                        >Selecione se contribui para a Preidência Social (INSS)</option>
                        <option value="S">Sim</option>
                        <option value="N">Não</option>
                        <has-error :form="form" field="contribui_inss"></has-error>
                      </select>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="inscrito_mei">É Inscrito no MEI (Micro Empreendedor Individual)*</label>
                      <select
                        v-model="form.inscrito_mei"
                        class="form-control"
                        id="inscrito_mei"
                        :class="{ 'is-invalid': form.errors.has('inscrito_mei') }"
                      >
                        <option
                          value
                          disabled
                        >Selecione se é inscrito no MEI (Micro Empreendedor Individual)</option>
                        <option value="S">Sim</option>
                        <option value="N">Não</option>
                      </select>
                      <has-error :form="form" field="inscrito_mei"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="cnpj">Se sim, preencher o nº do CNPJ</label>
                      <input
                        type="text"
                        v-mask="'##.###.###/####-##'"
                        name="cnpj"
                        id="cnpj"
                        v-model="form.cnpj"
                        placeholder="Digite o nº do CNPJ"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('cnpj') }"
                      />
                      <has-error :form="form" field="cnpj"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="interesse_mei">Se não, tem interesse em se inscrever</label>
                      <select
                        v-model="form.interesse_mei"
                        class="form-control"
                        id="interesse_mei"
                        :class="{ 'is-invalid': form.errors.has('interesse_mei') }"
                      >
                        <option value disabled>Selecione se tem interesse em se inscrever</option>
                        <option value="S">Sim</option>
                        <option value="N">Não</option>
                      </select>
                    </div>
                    <has-error :form="form" field="interesse_mei"></has-error>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label
                        for="renda_salario_minimo"
                      >Renda média mensal individual, só com artesanato*</label>
                      <select
                        class="form-control"
                        v-model="form.renda_salario_minimo"
                        id="renda_salario_minimo"
                        :class="{ 'is-invalid': form.errors.has('renda_salario_minimo') }"
                      >
                        <option value disabled>Selecione a renda média mensal individual</option>
                        <option>Menos de 1</option>
                        <option>De 1 a 3</option>
                        <option>Mais de 3 até 5</option>
                        <option>Mais de 5 até 10</option>
                        <option>Acima de 10</option>
                      </select>
                      <has-error :form="form" field="renda_salario_minimo"></has-error>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="renda_media">Renda média total*</label>
                      <select
                        class="form-control"
                        v-model="form.renda_media"
                        id="renda_media"
                        :class="{ 'is-invalid': form.errors.has('renda_media') }"
                      >
                        <option value disabled>Selecione a total</option>
                        <option>Menos de 1</option>
                        <option>De 1 a 3</option>
                        <option>Mais de 3 até 5</option>
                        <option>Mais de 5 até 10</option>
                        <option>Acima de 10</option>
                      </select>
                      <has-error :form="form" field="renda_salario_minimo"></has-error>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="fonte_renda">Maior fonte de renda familiar</label>
                      <select
                        v-model="form.fonte_renda"
                        class="form-control"
                        id="fonte_renda"
                        :class="{ 'is-invalid': form.errors.has('fonte_renda') }"
                      >
                        <option value disabled>Selecione a maior fonte de renda familiar</option>
                        <option>Atividade Artesanal</option>
                        <option>Outras atividades</option>
                      </select>
                      <has-error :form="form" field="fonte_renda"></has-error>
                    </div>
                  </div>
                  <div class="form-group">
                    <h6 class="text-muted">6. Comercialização</h6>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label
                        for="venda_maior_producao"
                      >Para quem vende a maior parte da sua produção*</label>
                      <select
                        v-model="form.venda_maior_producao"
                        class="form-control"
                        id="venda_maior_producao"
                        :class="{ 'is-invalid': form.errors.has('venda_maior_producao') }"
                      >
                        <option
                          value
                          disabled
                        >Selecione para quem vende a maior parte da sua produção</option>
                        <option>Lojistas (atacado)</option>
                        <option>Org. de Apoio ao artesanato</option>
                        <option>Consumidor final (varejo)</option>
                        <option>Outros</option>
                      </select>
                      <has-error :form="form" field="venda_maior_producao"></has-error>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="venda_maior_producao_descricao">Especificar</label>
                      <input
                        v-model="form.venda_maior_producao_descricao"
                        type="text"
                        id="venda_maior_producao_descricao"
                        name="venda_maior_producao_descricao"
                        placeholder="Digite para quem vende a maior parte da sua produção"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('venda_maior_producao_descricao') }"
                      />
                      <has-error :form="form" field="venda_maior_producao_descricao"></has-error>
                    </div>
                    <div class="form-group col-md-4">
                      <label
                        for="destino_final_producao"
                      >Principal destino final da sua produção(mercado)</label>
                      <select
                        v-model="form.destino_final_producao"
                        class="form-control"
                        id="destino_final_producao"
                        :class="{ 'is-invalid': form.errors.has('destino_final_producao') }"
                      >
                        <option
                          value
                          disabled
                        >Selecione o principal destino final da sua produção(mercado)</option>
                        <option>Local</option>
                        <option>Estadual</option>
                        <option>Nacional</option>
                        <option>Internacional</option>
                      </select>
                      <has-error :form="form" field="destino_final_producao"></has-error>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="tipo_venda">Qual o tipo de venda mais utilizado por você*</label>
                      <select v-model="form.tipo_venda" class="form-control" id="tipo_venda">
                        <option value disabled>Selecione o tipo de venda mais utilizado por você</option>
                        <option>Por encomenda para lojistas (atacado)</option>
                        <option>Em consignação</option>
                        <option>Direta ao consumidor (varejo)</option>
                        <option>Outros</option>
                      </select>
                      <has-error :form="form" field="tipo_venda"></has-error>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="tipo_venda_descricao">Especificar</label>
                      <input
                        v-model="form.tipo_venda_descricao"
                        type="text"
                        id="tipo_venda_descricao"
                        name="tipo_venda_descricao"
                        placeholder="Digite o tipo de venda mais utilizado por você"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('tipo_venda_descricao') }"
                      />
                      <has-error :form="form" field="tipo_venda_descricao"></has-error>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label for="onde_vende_producao">Onde vende a maior parte da sua produção</label>
                      <select
                        v-model="form.onde_vende_producao"
                        class="form-control"
                        id="onde_vende_producao"
                        :class="{ 'is-invalid': form.errors.has('tipo_venda_descricao') }"
                      >
                        <option value disabled>Selecione onde vende a maior parte da sua produção</option>
                        <option>Em casa e/ou oficina</option>
                        <option>No domicílio do comprador</option>
                        <option>Nas feiras</option>
                        <option>Nas ruas ou em praças</option>
                        <option>Siites de comercialização/Comércio eletrônico</option>
                        <option>Nas lojas</option>
                        <option>Outros</option>
                      </select>
                      <has-error :form="form" field="onde_vende_producao"></has-error>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="onde_vende_producao_descricao">Especificar</label>
                      <input
                        v-model="form.onde_vende_producao_descricao"
                        type="text"
                        name="onde_vende_producao_descricao"
                        placeholder="Digite onde vende a maior parte da sua produção"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('onde_vende_producao_descricao') }"
                      />
                      <has-error :form="form" field="onde_vende_producao"></has-error>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-6">
                      <label
                        for="forma_pagamento"
                      >Qual a forma de pagamento mais utilizada pelos seus clientes*</label>
                      <select
                        v-model="form.forma_pagamento"
                        class="form-control"
                        id="forma_pagamento"
                        :class="{ 'is-invalid': form.errors.has('forma_pagamento') }"
                      >
                        <option
                          value
                          disabled
                        >Selecione a forma de pagamento mais utilizada pelos seus clientes</option>
                        <option>Dinheiro</option>
                        <option>Cheque à vista</option>
                        <option>Cartão de crédito</option>
                        <option>Cartão de débito</option>
                        <option>Cheque a prazo</option>
                      </select>
                      <has-error :form="form" field="forma_pagamento"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="residuos_producao">Existem resíduos em sua produção</label>
                      <select
                        v-model="form.residuos_producao"
                        class="form-control"
                        id="residuos_producao"
                        :class="{ 'is-invalid': form.errors.has('residuos_producao') }"
                      >
                        <option value disabled>Selecione se existem resíduos em sua produção</option>
                        <option>Sim</option>
                        <option>Não</option>
                      </select>
                      <has-error :form="form" field="residuos_producao"></has-error>
                    </div>
                    <div class="form-group col-md-3">
                      <label for="residuos_producao_descricao">Especificar</label>
                      <input
                        v-model="form.residuos_producao_descricao"
                        type="text"
                        name="residuos_producao_descricao"
                        placeholder="Digite quais resíduos existem em sua produção"
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('residuos_producao_descricao') }"
                      />
                      <has-error :form="form" field="residuos_producao_descricao"></has-error>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="pills-contact"
                  role="tabpanel"
                  aria-labelledby="pills-contact-tab"
                  :class="{ 'active show': isActive('producao') }"
                >
                  <div class="form-edit" v-show="!editMode">
                    <div class="form-group">
                      <h6 class="text-muted">7. Classificação</h6>
                    </div>
                    <div class="form-group col-md-12">
                      <label>Selecione os tipos de artesanatos</label>
                      <div
                        v-for="(artesanatos, key, index) in groupArtesanatos"
                        :key="index"
                        class="row"
                      >
                        <div
                          class="col-sm-6"
                          v-for="(value, key, index) in artesanatos"
                          :key="index"
                        >
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                :id="value.id+'artesanato'"
                                :value="value.id"
                                v-model="form.checked_artesanatos"
                              />
                              <label
                                :for="value.id+'artesanato'"
                                class="custom-control-label"
                              >{{value.descricao}}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-md-12">
                      <label>Especifique os trabalhos manuais</label>
                      <div
                        v-for="(trabalhos, key, index) in groupTrabalhos"
                        :key="index"
                        class="row"
                      >
                        <div class="col-sm-6" v-for="(value, key, index) in trabalhos" :key="index">
                          <div class="form-group">
                            <div class="custom-control custom-checkbox">
                              <input
                                class="custom-control-input"
                                type="checkbox"
                                :id="value.id+'_trabalho'"
                                :value="value.id"
                                v-model="form.checked_trabalhos"
                              />
                              <label
                                :for="value.id+'_trabalho'"
                                class="custom-control-label"
                              >{{value.descricao}}</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <h6 class="text-muted">8. Foto de Perfil</h6>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-2 text-center">
                      <img
                        class="profile-user-img img-fluid"
                        :src="getPhotoCadastro()"
                        alt="Profile image example"
                      />
                    </div>
                    <div class="form-group col-md-6">
                      <label for="photo" class>Selecione a foto do perfil</label>
                      <input type="file" id="photo" class="form-control" @change="photoCadastro" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
              <button
                @click.prevent="prevTabInfo"
                v-show="activeItem==='producao'"
                type="button"
                class="btn btn-secondary"
              >Anterior</button>
              <button
                @click.prevent="prevTabPrincipal"
                v-show="activeItem==='info'"
                type="button"
                class="btn btn-secondary"
              >Anterior</button>
          <!--     <button
                v-if="editMode&&activeItem==='producao'"
                :disabled="form.busy"
                @click.prevent="updateArt"
                class="btn btn-success"
              >Alterar</button> -->
              <button
                v-if="!editMode&&activeItem==='producao'"
                :disabled="form.busy"
                @click.prevent="createArt"
                class="btn btn-primary"
              >Salvar</button>

              <button
                v-show="activeItem === 'principal'"
                class="btn btn-primary"
                @click.prevent="nextTabInfo"
                :disabled="isDisabledPrincipal"
              >Próxima</button>

              <!--  <button class="btn" type="submit" >Submit</button> -->

              <button
                v-show="activeItem === 'info'"
                :disabled="isDisabledInfo"
                class="btn btn-primary"
                @click.prevent="nextTabProducao"
              >Próxima</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>




<script>
export default {
  data() {
    return {
      activeItem: "principal",
      editMode: true,
      arts: {},
      urgs: {},
      problemas: {},
      escolaridades: {},
      trabalhos: {},
      artesanatos: {},
      form: new Form({
        id: "",
        nome: "",
        perfil_facebook: "",
        cpf: "",
        identidade: "",
        orgao_exp: "",
        data_emissao: "",
        data_nascimento: "",
        nome_pai: "",
        nome_mae: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cep: "",
        uf: "",
        localidade: "",
        email: "",
        telefone: "",
        celular: "",
        sexo: "",
        estado_civil: "",
        quantidade_dependente: "",
        vive_imovel: "",
        portador_necessidades: "",
        portador_necessidades_descricao: "",
        etnia: "",
        tempo_artesao: "",
        atividade: "",
        causa_ingresso: "",
        vinculo_institucional: "",
        instrutor_tecnico: "",
        instrutor_tecnico_descricao: "",
        instrutor_tecnico_ano: "",
        como_conheceu: "",
        atividade_capacitacao: "",
        tipo_capacitacao: "",
        tipo_capacitacao_descricao: "",
        area_capacitacao: "",
        nome_capacitacao: "",
        carga_horaria_capacitacao: "",
        data_capacitacao: "",
        entidade_capacitacao: "",
        local_capacitacao: "",
        local_producao: "",
        local_producao_descricao: "",
        sistema_trabalho: "",
        sistema_trabalho_descricao: "",
        horas_dedicadas: "",
        contribui_inss: "",
        inscrito_mei: "",
        cnpj: "",
        interesse_mei: "",
        renda_salario_minimo: "",
        fonte_renda: "",
        venda_maior_producao: "",
        venda_maior_producao_descricao: "",
        destino_final_producao: "",
        tipo_venda: "",
        tipo_venda_descricao: "",
        onde_vende_producao: "",
        onde_vende_producao_descricao: "",
        forma_pagamento: "",
        residuos_producao: "",
        residuos_producao_descricao: "",
        urg_id: "",
        photo: "",
        escolaridade_id: "",
        checked_participar_feira: "",
        checked_desconto: "",
        renda_media: "",
        checked_problemas: [],
        checked_trabalhos: [],
        checked_artesanatos: []
      })
    };
  },
  computed: {
    isDisabledPrincipal() {
      if (
        this.form.nome.length > 8 &&
        this.form.cpf.length == 14 &&
        this.form.identidade.length == 12 &&
        this.form.data_nascimento.length != "" &&
        this.form.logradouro.length > 3 &&
        this.form.numero.length > 1 &&
        this.form.bairro.length > 5 &&
        this.form.cep.length == 9 &&
        this.form.uf.length > 1 &&
        this.form.urg_id != "" &&
        this.form.telefone.length > 8 &&
        this.form.escolaridade_id != "" &&
        this.form.sexo != "" &&
        this.form.estado_civil != "" &&
        this.form.vive_imovel != "" &&
        this.form.etnia != "" &&
        this.form.portador_necessidades != "" &&
        this.form.tempo_artesao != "" &&
        this.form.atividade != "" &&
        this.form.vinculo_institucional != "" &&
        this.form.instrutor_tecnico != ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledInfo() {
      if (
        this.form.local_producao != "" &&
        this.form.sistema_trabalho != "" &&
        this.form.contribui_inss != "" &&
        this.form.inscrito_mei != "" &&
        this.form.renda_salario_minimo != "" &&
        this.form.renda_media != "" &&
        this.form.venda_maior_producao != "" &&
        this.form.tipo_venda != "" &&
        this.form.forma_pagamento != ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    groupProblemas() {
      return _.chunk(this.problemas, 6);
    },

    groupTrabalhos() {
      return _.chunk(this.trabalhos, 6);
    },

    groupArtesanatos() {
      return _.chunk(this.artesanatos, 6);
    }
  },
  methods: {
    getResults(page = 1) {
      axios.get("api/artesoes?page=" + page).then(response => {
        this.arts = response.data;
      });
    },
    updateArt() {
      console.log("editar");
      this.$Progress.start();
      this.form
        .put("api/artesoes/" + this.form.id)
        .then(() => {
          $("#addNew").modal("hide");
          swal.fire("Alterado", "Usuário alterado com sucesso.", "success");
          this.$Progress.finish();
          Fire.$emit("AfterCreate");
        })
        .catch(() => {
          this.$Progress.fail();
        });
    },
    editModal(art) {
      this.editMode = true;
      this.form.reset();
      this.loadUrgs();
      this.loadEscolaridades();
      this.loadProblemas();
      this.loadArtesanatos();
      this.loadTrabalhos();
      $("#pills-home-tab").tab("show");
      this.setActive("principal");
      $("#addNew").modal("show");
      this.form.fill(art);
      console.log(art);
    },
    newModal() {
      this.editMode = false;
      this.form.reset();
      this.loadUrgs();
      this.loadEscolaridades();
      this.loadProblemas();
      this.loadArtesanatos();
      this.loadTrabalhos();
      $("#pills-home-tab").tab("show");
      this.setActive("principal");
      $("#addNew").modal("show");
    },
    deleteArt(id) {
      swal
        .fire({
          title: "Tem certeza?",
          text: "Após excluir, não será possível a reversão!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, deletar!"
        })
        .then(result => {
          if (result.value) {
            this.form
              .delete("/api/artesoes/" + id)
              .then(() => {
                swal.fire("OK!", "Usuário deletado com sucesso.", "success");
                Fire.$emit("AfterCreate");
              })
              .catch(() => {
                swal.fire("Erro!", "Favor tentar novamente.", "warning");
              });
          }
        });
    },

    loadArts() {
      if (this.$gate.isAdminOrAuthor()) {
        axios.get("api/artesoes").then(({ data }) => (this.arts = data));
      }
    },

    loadUrgs() {
      if (this.$gate.isAdminOrAuthor()) {
        axios.get("api/urgs").then(({ data }) => (this.urgs = data));
      }
    },

    loadEscolaridades() {
      if (this.$gate.isAdminOrAuthor()) {
        axios
          .get("api/escolaridades")
          .then(({ data }) => (this.escolaridades = data));
      }
    },
    loadProblemas() {
      if (this.$gate.isAdminOrAuthor()) {
        axios.get("api/problemas").then(({ data }) => (this.problemas = data));
      }
    },
    loadArtesanatos() {
      if (this.$gate.isAdminOrAuthor()) {
        axios
          .get("api/listArtesanatos")
          .then(({ data }) => (this.artesanatos = data));
      }
    },

    loadTrabalhos() {
      if (this.$gate.isAdminOrAuthor()) {
        axios
          .get("api/listTrabalhos")
          .then(({ data }) => (this.trabalhos = data));
      }
    },
    createArt() {
      console.log("inserir");
      this.$Progress.start();
      this.form
        .post("api/artesoes")
        .then(() => {
          Fire.$emit("AfterCreate");
          $("#addNew").modal("hide");

          toast.fire({
            icon: "success",
            title: "Artesão cadastrado com sucesso"
          });
        })
        .catch(() => {
          swal.fire(
            "Erro!",
            "Verifique os campos obrigatórios e tente novamente.",
            "warning"
          );
          this.$Progress.fail();
        });

      this.$Progress.finish();
    },

    isActive(menuItem) {
      return this.activeItem === menuItem;
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
      console.log(this.activeItem);
    },
    nextTabInfo() {
      $("#pills-profile-tab").tab("show");
      this.setActive("info");
    },

    nextTabProducao() {
      $("#pills-profile-tab").tab("show");
      this.setActive("producao");
    },
    prevTabInfo() {
      $("#pills-profile-tab").tab("show");
      this.setActive("info");
    },

    prevTabPrincipal() {
      $("#pills-profile-tab").tab("show");
      this.setActive("principal");
    },
    photoCadastro(e) {
      let file = e.target.files[0];
      let reader = new FileReader();

      if (file["size"] < 2097152) {
        reader.onloadend = file => {
          console.log("result", reader.result);
          this.form.photo = reader.result;
        };
        reader.readAsDataURL(file);
      } else {
        swal.fire("Erro!", "Imagem superior a 2MB", "error");
      }
    },
    getPhotoCadastro() {
      let prefix = "";
      if (this.form.photo == "") {
        prefix = this.form.photo.match(/\//) ? "" : "/img/profile.png";
      } else {
        prefix = this.form.photo.match(/\//) ? "" : "/img/arts/";
      }
      return prefix + this.form.photo;
    }
  },

  created() {
    this.loadArts();
    Fire.$on("AfterCreate", () => {
      this.loadArts();
    });
    // setInterval(() => this.loadUsers(), 3000);
  }
};
</script>
